<template>
  <div>
    <svg viewBox="0 0 37 100" class="svg">
      <!-- eslint-disable-next-line max-len -->
      <path id="man"
            d="M18.5,18.75c5.18,0,9.38-4.2,9.38-9.38S23.68,0,18.5,0S9.12,4.2,9.12,9.38S13.32,18.75,18.5,18.75z M33.19,21.88H3.81 c-2.07,0-3.75,1.68-3.75,3.75v33.12c0,2.07,1.68,3.75,3.75,3.75s3.75-1.68,3.75-3.75V29.38h1.56v66.88c0,2.07,1.68,3.75,3.75,3.75 s3.75-1.68,3.75-3.75V60.62h3.75v35.62c0,2.07,1.68,3.75,3.75,3.75s3.75-1.68,3.75-3.75V29.38h1.56v29.38 c0,2.07,1.68,3.75,3.75,3.75s3.75-1.68,3.75-3.75V25.62C36.94,23.55,35.26,21.88,33.19,21.88z"/>
    </svg>
    <gallery :images="images" :index="index" @close="index=null"/>

    <div
      class="media room-card"
      v-for="inventoryType in blockInventoryTypes"
      v-bind:key="inventoryType.id"
    >

      <div class="media-left media-top image" v-if="inventoryType.images.length > 0" @click="openGallery(inventoryType)">
        <img class="media-object" :src="inventoryType.images[0].photo" width="300px">
      </div>

      <div class="media-body">
        <div class="media-head">
          <h3 class="media-heading">{{ inventoryType.name }}
            <p title="Вместимость">
              <i
                class="icon-man"
                v-for="(places, i) in inventoryType.standard_places_count"
                v-bind:key="i"
              >
                <svg class="icon" viewBox="0 0 37 100">
                  <use xlink:href="#man"></use>
                </svg>
              </i>
              <span
                v-if="inventoryType.extra_places_count > 0"
              >+
                <i
                  class="icon-man"
                  v-for="(places, i) in inventoryType.extra_places_count"
                  v-bind:key="i"
                >
                  <svg class="icon" viewBox="0 0 37 100">
                    <use xlink:href="#man"></use>
                  </svg>
                </i></span>
            </p>
          </h3>

          <div>
            <selectTypeBtn
              :status="bookingBtn(inventoryType.id)"
              @click.native="selectInventoryType(inventoryType.id)"
            />
          </div>
        </div>
        <p v-html="inventoryType.description"></p>

      </div>
      <div v-if="inventoryType.id === selectedInventoryType">
        <h4 class="title">Выберите тариф</h4>
        <app-rate-plan-client-select
          :inventoryType="selectedInventoryType"
          :dateRange="dateRange"
          :inventoryBlock="inventoryBlock"
          :guestCount="guestCount"
          @totalAmountChanged="totalPlacingAmount=$event"
          @ratePlanChanged="ratePlan=$event"
          @roomRatesChanged="roomRates=$event"
        ></app-rate-plan-client-select>
        <!--<app-extra-service-select
          :inventoryType="selectedInventoryType"
          :ratePlan="ratePlan"
          :dateRange="dateRange"
          :guestCount="guestCount"
          :totalPlacingAmount="totalPlacingAmount"
          @extraServiceChanged="extraServices=$event"
        ></app-extra-service-select>-->

        <div class="card" v-if="ratePlan">
          <div class="card-body">
            <app-guest-form
              :guestsComposition="guestCount"
              @guestsChanged="guests = $event"
            ></app-guest-form>
            <app-contact-form
              @contactInfoChanged="contactInfo = $event"
            ></app-contact-form>
            <div class="text-center">
              <p v-if="agreementHyperlink">
                Нажимая "забронировать" вы соглашаетесь с <a v-bind:href="agreementHyperlink" target="_blank">правилами онлайн-бронирования, обработкой
                персональных данных и политикой конфиденциальности</a>
              </p>
              <input
                type="submit"
                :disabled="!guests || !contactInfo"
                @click="createReservation"
                class="btn btn-large btn-rose btn-raised btn-round"
                value="Забронировать"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import VueGallery from 'vue-gallery';
import RatePlanClientSelect from './RatePlanClientSelect.vue';
import SelectInventoryTypeBtn from './SelectInventoryTypeBtn.vue';
import GuestForm from '../booking/GuestForm.vue';
import ContactForm from '../booking/ContactForm.vue';

export default {
  name: 'InventoryTypeSelect',
  props: [
    'dateRange',
    'inventoryBlock',
    'guestCount',
    'inventoryTypePrices',
  ],
  components: {
    appRatePlanClientSelect: RatePlanClientSelect,
    appGuestForm: GuestForm,
    appContactForm: ContactForm,
    gallery: VueGallery,
    selectTypeBtn: SelectInventoryTypeBtn,
  },
  data() {
    return {
      daysWings: 0, //  added days to selected daterange interval
      inventoryAvailability: null,
      dateRangeList: null,
      ratePlan: null,
      roomRates: null,
      totalPlacingAmount: null,
      extraServices: null,
      contactInfo: null,
      guests: null,
      index: null,
      images: [],
      agreementHyperlink: null,
    };
  },
  computed: {
    blockInventoryTypes() { // Возвращает только те типы комнат, которые прикреплены к отелю выбранного блока
      const blk = this.inventoryBlocks.find(b => String(b.id) === String(this.inventoryBlock));
      if (blk) {
        return this.inventoryTypes.filter(t => t.hotel === blk.hotel.id && t.is_active);
      }
      return this.inventoryTypes.filter(t => t.is_active);
    },
    ...mapGetters([
      'inventoryTypes',
      'ageQualifiers',
      'inventoryBlocks',
      'selectedInventoryType',
    ]),
    totalGuests() {
      if (this.guestCount) {
        const totalGuests = {
          totalPlaces: 0,
          onlyAdditionalPlaces: 0,
        };
        this.guestCount.forEach((guest) => {
          let ageQualifier = null;
          if (guest.age_qualifier) {
            ageQualifier = this.ageQualifiers.find(a => a.id === Number(guest.age_qualifier));
          }
          if (ageQualifier === null || !ageQualifier.no_place) {
            totalGuests.totalPlaces += Number(guest.persons);
            if (ageQualifier) {
              if (!ageQualifier.settle_to_main_place) {
                totalGuests.onlyAdditionalPlaces += Number(guest.persons);
              }
            }
          }
        });
        return totalGuests;
      }
      return null;
    },
    roomAvailability() {
      if (this.inventoryAvailability) {
        // Create a dictionary of availability{'inv_type_id': true|false}
        const roomAvail = {};
        this.inventoryAvailability.forEach((availability) => {
          roomAvail[availability.inventory_type] = true;
          availability.dates.forEach((av) => {
            if (!(availability.dates.find(a => a.date === av.date).avail > 0)) {
              roomAvail[availability.inventory_type] = false;
            }
          });
        }, this);
        return roomAvail;
      }
      return null;
    },
  },
  watch: {
    ratePlan() {
      this.$emit('ratePlanChanged', this.ratePlan);
    },
    roomRates() {
      this.$emit('roomRatesChanged', this.roomRates);
    },
    contactInfo() {
      this.$emit('contactInfoChanged', this.contactInfo);
    },
    guests() {
      this.$emit('guestsChanged', this.guests);
    },
    totalPlacingAmount() {
      this.$emit('totalAmountChanged', this.totalPlacingAmount);
    },
    dateRange() {
      this.updateAvailability();
    },
    inventoryBlock() {
      this.updateAvailability();
      const blk = this.inventoryBlocks.find(b => String(b.id) === String(this.inventoryBlock));
      if (blk) {
        this.agreementHyperlink = blk.hotel.agreement_hyperlink;
      }
    },
    selectedInventoryType() {
      this.$emit('inventoryTypeChanged', this.selectedInventoryType);
    },
  },
  methods: {
    createReservation() {
      this.$emit('createReservation');
    },
    updateAvailability() {
      this.inventoryAvailability = null;
      if (this.dateRange && this.inventoryBlock) {
        let dateFrom = moment(this.dateRange.date_from).subtract(this.daysWings, 'days').format('YYYY-MM-DD');
        if (dateFrom < moment(Date.now()).format('YYYY-MM-DD')) {
          dateFrom = moment(Date.now()).format('YYYY-MM-DD');
        }
        axios.get('/api/availability/',
          {
            params: {
              date_from: dateFrom,
              date_to: moment(this.dateRange.date_to).add(this.daysWings, 'days').format('YYYY-MM-DD'),
              inventory_block: this.inventoryBlock,
            },
          })
          .then((response) => {
            this.inventoryAvailability = response.data.inventory_availability;
            if (this.inventoryAvailability.length > 0) {
              this.dateRangeList = this.inventoryAvailability[0].dates.map(d => d.date);
            }
            this.selectInventoryType(this.selectedInventoryType);
          })
          .catch(() => {
            this.mutateInventoryType(null);
            this.inventoryAvailability = null;
            this.dateRangeList = null;
          });
      } else {
        this.selectInventoryType(null);
      }
    },
    getInventoryType(id) {
      return (id === null) ? null : this.inventoryTypes.find(t => t.id === id);
    },
    getMinPrice(prices) {
      if (prices == null) {
        return null;
      }
      return Math.min(...prices.filter(p => p.amount).map(p => p.amount));
    },
    pricesIsValid(prices) {
      return prices ? Object.keys(prices).length : false;
    },
    bookingBtn(id) {
      const btn = {
        disabled: true,
      };

      if (this.checkPlacing(id)) {
        const prices = this.inventoryTypePrices;
        const validPrices = this.pricesIsValid(prices);
        if (this.roomAvailability && validPrices && prices[id]) {
          const moreOne = prices[id].length > 1;
          const price = this.getMinPrice(prices[id]);
          btn.text = `Забронировать ${moreOne ? 'от' : 'за'} ${price} ₽`;
          btn.disabled = false;
        } else if (!this.roomAvailability) {
          btn.text = 'Не осталось свободных номеров';
        } else {
          btn.text = 'Бронирование невозможно';
        }
      } else {
        btn.text = 'Невозможно разместить такое количество гостей';
      }
      return btn;
    },
    checkPlacing(invTypeId) {
      if (invTypeId == null) {
        return false;
      }
      // Return true if guests can placing to the room
      const inventoryType = this.inventoryTypes.find(a => a.id === invTypeId);
      const totalRoomPlaces = inventoryType.standard_places_count + inventoryType.extra_places_count;
      return (totalRoomPlaces >= this.totalGuests.totalPlaces && inventoryType.extra_places_count >= this.totalGuests.onlyAdditionalPlaces);
    },
    selectInventoryType(id) {
      if (this.checkPlacing(id)) {
        this.mutateInventoryType(id);
      } else {
        this.mutateInventoryType(null);
      }
    },
    openGallery(invType) {
      this.images = invType.images.map(p => p.photo);
      this.index = 0;
    },
    ...mapMutations(['mutateInventoryType']),
  },
};
</script>

<style lang="sass" scoped>
.btn-book span
  font-size: 160%
  color: #ffe0c6

.image
  cursor: pointer

.media-head
  display: flex
  justify-content: space-between

.svg
  position: absolute
  left: -999999px
  width: 0
  height: 0
  overflow: hidden

.icon
  width: 100%
  height: 100%

  &-man
    display: inline-block
    width: 7px
    height: 20px
    margin-right: 4px
    vertical-align: middle
    fill: #999
</style>
